// src/features/inventory/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import ScannerPage from './pages/ScannerPage';
import ScannerDevicePage from './pages/ScannerDevicePage';
import ItemListPage from './pages/ItemListPage';
import CreateItemPage from './pages/CreateItemPage';
import ItemDetailPage from './pages/ItemDetailPage';
import EditItemPage from './pages/EditItemPage';
import SupplierListPage from './pages/SupplierListPage';
import CreateSupplierPage from './pages/CreateSupplierPage';
import SupplierDetailPage from './pages/SupplierDetailPage';
import EditSupplierPage from './pages/EditSupplierPage';
import BatchListPage from './pages/BatchListPage';
import BatchDetailPage from './pages/BatchDetailPage';
import MSDSListPage from './pages/MSDSListPage';
import TestBarcodesPage from './pages/TestBarcodesPage';
import { SCANNER_STAFF_SCOPES, TEST_BARCODE_SCOPES } from './scannerScopes';

// A phone logged in as a scanner. Public: the page checks its own device session.
export const InventoryScannerDeviceRoutes = () => (
  <Route path="/scanner" element={<ScannerDevicePage />} />
);

export const InventoryScannerRoutes = () => (
  <Route path="inventory">
    <Route
      path="scanner"
      element={
        <ProtectedRoute requiredScopes={SCANNER_STAFF_SCOPES} requireAll>
          <ScannerPage />
        </ProtectedRoute>
      }
    />
  </Route>
);

export const InventoryRoutes = () => (
  <Route path="inventory">
    <Route path="items">
      <Route
        index
        element={
          <ProtectedRoute requiredScope="inventory:item:read">
            <ItemListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute requiredScope="inventory:item:create">
            <CreateItemPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":itemId"
        element={
          <ProtectedRoute requiredScope="inventory:item:read">
            <ItemDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":itemId/edit"
        element={
          <ProtectedRoute requiredScope="inventory:item:update">
            <EditItemPage />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="suppliers">
      <Route
        index
        element={
          <ProtectedRoute requiredScope="inventory:supplier:read">
            <SupplierListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute requiredScope="inventory:supplier:create">
            <CreateSupplierPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":supplierId"
        element={
          <ProtectedRoute requiredScope="inventory:supplier:read">
            <SupplierDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":supplierId/edit"
        element={
          <ProtectedRoute requiredScope="inventory:supplier:update">
            <EditSupplierPage />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="msds">
      <Route
        index
        element={
          <ProtectedRoute requiredScope="inventory:msds:read">
            <MSDSListPage />
          </ProtectedRoute>
        }
      />
    </Route>

    {/* Hidden: no menu entry. Test codes for demoing the phone scanner */}
    <Route
      path="test-barcodes"
      element={
        <ProtectedRoute requiredScopes={TEST_BARCODE_SCOPES} requireAll>
          <TestBarcodesPage />
        </ProtectedRoute>
      }
    />

    <Route path="batches">
      <Route
        index
        element={
          <ProtectedRoute requiredScope="inventory:lot:read">
            <BatchListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":lotId"
        element={
          <ProtectedRoute requiredScope="inventory:lot:read">
            <BatchDetailPage />
          </ProtectedRoute>
        }
      />
    </Route>
  </Route>
);
